"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "BrowserDetection", {
  enumerable: true,
  get: function get() {
    return _browserDetection.default;
  }
});
_Object$defineProperty(exports, "Defer", {
  enumerable: true,
  get: function get() {
    return _defer.default;
  }
});
_Object$defineProperty(exports, "Exception", {
  enumerable: true,
  get: function get() {
    return _exception.default;
  }
});
_Object$defineProperty(exports, "INTERNAL_US_CLUSTER_NAME", {
  enumerable: true,
  get: function get() {
    return _constants.INTERNAL_US_CLUSTER_NAME;
  }
});
_Object$defineProperty(exports, "INTERNAL_US_INTEGRATION_CLUSTER_NAME", {
  enumerable: true,
  get: function get() {
    return _constants.INTERNAL_US_INTEGRATION_CLUSTER_NAME;
  }
});
_Object$defineProperty(exports, "SDK_EVENT", {
  enumerable: true,
  get: function get() {
    return _constants.SDK_EVENT;
  }
});
_Object$defineProperty(exports, "base64", {
  enumerable: true,
  get: function get() {
    return _base.default;
  }
});
_Object$defineProperty(exports, "buildHydraMembershipId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.buildHydraMembershipId;
  }
});
_Object$defineProperty(exports, "buildHydraMessageId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.buildHydraMessageId;
  }
});
_Object$defineProperty(exports, "buildHydraOrgId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.buildHydraOrgId;
  }
});
_Object$defineProperty(exports, "buildHydraPersonId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.buildHydraPersonId;
  }
});
_Object$defineProperty(exports, "buildHydraRoomId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.buildHydraRoomId;
  }
});
_Object$defineProperty(exports, "cappedDebounce", {
  enumerable: true,
  get: function get() {
    return _cappedDebounce.default;
  }
});
_Object$defineProperty(exports, "checkRequired", {
  enumerable: true,
  get: function get() {
    return _checkRequired.default;
  }
});
_Object$defineProperty(exports, "constructHydraId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.constructHydraId;
  }
});
_Object$defineProperty(exports, "createEventEnvelope", {
  enumerable: true,
  get: function get() {
    return _eventEnvelope.createEventEnvelope;
  }
});
_Object$defineProperty(exports, "deconstructHydraId", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.deconstructHydraId;
  }
});
_Object$defineProperty(exports, "deprecated", {
  enumerable: true,
  get: function get() {
    return _deprecated.default;
  }
});
_Object$defineProperty(exports, "deviceType", {
  enumerable: true,
  get: function get() {
    return _constants.deviceType;
  }
});
_Object$defineProperty(exports, "ensureMyIdIsAvailable", {
  enumerable: true,
  get: function get() {
    return _eventEnvelope.ensureMyIdIsAvailable;
  }
});
_Object$defineProperty(exports, "getBrowserSerial", {
  enumerable: true,
  get: function get() {
    return _browserDetection.getBrowserSerial;
  }
});
_Object$defineProperty(exports, "getHydraClusterString", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.getHydraClusterString;
  }
});
_Object$defineProperty(exports, "getHydraFiles", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.getHydraFiles;
  }
});
_Object$defineProperty(exports, "getHydraRoomType", {
  enumerable: true,
  get: function get() {
    return _uuidUtils.getHydraRoomType;
  }
});
_Object$defineProperty(exports, "hydraTypes", {
  enumerable: true,
  get: function get() {
    return _constants.hydraTypes;
  }
});
_Object$defineProperty(exports, "inBrowser", {
  enumerable: true,
  get: function get() {
    return _inBrowser.default;
  }
});
_Object$defineProperty(exports, "isBuffer", {
  enumerable: true,
  get: function get() {
    return _isBuffer.default;
  }
});
_Object$defineProperty(exports, "make", {
  enumerable: true,
  get: function get() {
    return _templateContainer.default;
  }
});
_Object$defineProperty(exports, "makeStateDataType", {
  enumerable: true,
  get: function get() {
    return _makeStateDatatype.default;
  }
});
_Object$defineProperty(exports, "oneFlight", {
  enumerable: true,
  get: function get() {
    return _oneFlight.default;
  }
});
_Object$defineProperty(exports, "patterns", {
  enumerable: true,
  get: function get() {
    return _patterns.default;
  }
});
_Object$defineProperty(exports, "proxyEvents", {
  enumerable: true,
  get: function get() {
    return _events.proxyEvents;
  }
});
_Object$defineProperty(exports, "resolveWith", {
  enumerable: true,
  get: function get() {
    return _resolveWith.default;
  }
});
_Object$defineProperty(exports, "retry", {
  enumerable: true,
  get: function get() {
    return _retry.default;
  }
});
_Object$defineProperty(exports, "tap", {
  enumerable: true,
  get: function get() {
    return _tap.default;
  }
});
_Object$defineProperty(exports, "transferEvents", {
  enumerable: true,
  get: function get() {
    return _events.transferEvents;
  }
});
_Object$defineProperty(exports, "whileInFlight", {
  enumerable: true,
  get: function get() {
    return _whileInFlight.default;
  }
});
var _base = _interopRequireDefault(require("./base64"));
var _isBuffer = _interopRequireDefault(require("./isBuffer"));
var _cappedDebounce = _interopRequireDefault(require("./capped-debounce"));
var _checkRequired = _interopRequireDefault(require("./check-required"));
var _defer = _interopRequireDefault(require("./defer"));
var _makeStateDatatype = _interopRequireDefault(require("./make-state-datatype"));
var _templateContainer = _interopRequireDefault(require("./template-container"));
var _oneFlight = _interopRequireDefault(require("./one-flight"));
var _patterns = _interopRequireDefault(require("./patterns"));
var _events = require("./events");
var _eventEnvelope = require("./event-envelope");
var _resolveWith = _interopRequireDefault(require("./resolve-with"));
var _retry = _interopRequireDefault(require("./retry"));
var _tap = _interopRequireDefault(require("./tap"));
var _whileInFlight = _interopRequireDefault(require("./while-in-flight"));
var _exception = _interopRequireDefault(require("./exception"));
var _deprecated = _interopRequireDefault(require("./deprecated"));
var _inBrowser = _interopRequireDefault(require("./in-browser"));
var _constants = require("./constants");
var _browserDetection = _interopRequireWildcard(require("./browser-detection"));
var _uuidUtils = require("./uuid-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//# sourceMappingURL=index.js.map
